import { useSelector } from 'react-redux'

import { POST_PAYMENT_PROGRESS_BAR_COHORTS } from 'post-payment-config'

import { selectCurrentVariantCohortToUse } from 'root-redux/selects/common'

import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'

import { Cohort } from 'root-constants'

export const useShouldShowPostPaymentProgressBar = (): boolean => {
  const cohortToUse = useSelector(selectCurrentVariantCohortToUse)
  const { isAyah110MonthlyUpsellTest } = useExperimentalFeatures()

  return (
    POST_PAYMENT_PROGRESS_BAR_COHORTS.includes(cohortToUse as Cohort) ||
    isAyah110MonthlyUpsellTest
  )
}
